export const ServiceableServiceLevelHeader = [
  {
    header: "Category",
    key: "Category",
  },
  {
    header: "OnTime",
    key: "OnTime",
  },
  {
    header: "Delayed",
    key: "Delayed",
  },
];

export const ServiceableServiceLevelName = "Serviceable Service Level";

export const ServiceableServiceLevelDetailHeaders = [
  {
    header: "Contract",
    key: "Contract",
  },
  {
    header: "Ref No",
    key: "Ref No",
  },
  {
    header: "Category",
    key: "Category",
  },
  {
    header: "Requested Pn",
    key: "Requested Pn",
  },
  {
    header: "Serviceable Awb",
    key: "Serviceable Awb",
  },
  {
    header: "Serviceable Forward Date",
    key: "Serviceable Forward Date",
  },
  {
    header: "Core Unit Forward Date",
    key: "Core Unit Forward Date",
  },
  {
    header: "Requested Delivery Date",
    key: "Requested Delivery Date",
  },
  {
    header: "Customer Po",
    key: "Customer Po",
  },
  {
    header: "Delayed",
    key: "Delayed",
  },
];

export const ServiceableServiceLevelDetailHeadersTtUser = [
  ...ServiceableServiceLevelDetailHeaders,
  {
    header: "Cargo Accepted Date (RCS)",
    key: "Cargo Accepted Date",
  },
  {
    header: "Cargo Accepted Location",
    key: "Cargo Accepted Location",
  },
  {
    header: "Cargo Departure Date (DEP)",
    key: "Cargo Departure Date",
  },
  {
    header: "Cargo Departure Location",
    key: "Cargo Departure Location",
  },
  {
    header: "Cargo Departure Flight",
    key: "Cargo Departure Flight",
  },
  {
    header: "Cargo Arrival Date (RCF)",
    key: "Cargo Arrival Date",
  },
  {
    header: "Cargo Arrival Location",
    key: "Cargo Arrival Location",
  },
  {
    header: "Cargo Arrival Flight",
    key: "Cargo Arrival Flight",
  },
  {
    header: "Transit Days (DEP→RCF)",
    key: "Transit Days",
  },
  {
    header: "Fwd→Arrival Days (Forward→RCF)",
    key: "Fwd→Arrival Days",
  },
  {
    header: "Waiting Days (Forward→RCS)",
    key: "Waiting Days",
  },
];

export const ServiceableServiceLevelDetailName = "Serviceable Service Level Detail";
